import { Form, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import { capitalize } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { addKeyInArray } from "../../../helpers/siteConfig";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import { getCompletedTowerBySupplierAsync } from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import {
  GetCompletedTowerBySupplierData,
  GetCompletedTowerBySupplierParams,
} from "../../../types/redux/NP/supplier";
import ConfirmModal from "../../common/ConfirmModal";
import CustomTable from "../../common/CustomTable";

interface NetworkTableColumn {
  _id: string;
  key: number;
  siteCode: string;
  towerName: string;
  pg: {
    firstName: string;
    lastName: string;
  };
  regionName: string;
  areaName: string;
  teritoryName: string;
  minutesOfWork: number;
  paid: boolean;
  regionCheck?: boolean;
  superAdminCheck?: boolean;
  amount?: number;
  missCall?: boolean;
  totalValidRunTime?: number;
  // other properties
}

interface CompletedTaskTableProps {
  keyword?: string;
  siteCode?: string;
  addOpen: any;
  addToggle: () => void;
  selectedRowKeys: any;
  setSelectedRowKeys: any;
  filter?: {
    regionId?: string;
    areaId?: string;
  };
}

export default function CompletedTaskTable({
  keyword = "",
  siteCode = "",
  addOpen,
  selectedRowKeys,
  setSelectedRowKeys,
  addToggle,
  filter,
}: CompletedTaskTableProps) {
  const dispatch = useAppDispatch();
  const { limit, page, handlePagination } = useTable();
  const { login } = useAppSelector((state) => state.login);
  const [form] = Form.useForm();
  const {
    loading,
    postLoading,
    allCompletedTowerBySupplier,
    completedTowerPaginationResponse,
  } = useAppSelector((state) => state.supplier);
  const {
    open: confirmOpen,
    toggle: confirmToggle,
    handleOpen: handleConfirmOpen,
  } = useModal();
  const [tableData, setTableData] = useState<NetworkTableColumn[]>([
    {
      _id: "abc1",
      key: 1, // ✅ number instead of "1"
      siteCode: "SL-1001",
      towerName: "Main Tower",
      pg: {
        firstName: "John",
        lastName: "Doe",
      },
      regionName: "North",
      areaName: "Area 1",
      teritoryName: "Territory A",
      minutesOfWork: 120,
      missCall: true,
      totalValidRunTime: 123.45,
      amount: 5000,
      paid: false,
    },
    {
      _id: "abc2",
      key: 2,
      siteCode: "SL-1002",
      towerName: "West Tower",
      pg: {
        firstName: "Jane",
        lastName: "Smith",
      },
      regionName: "West",
      areaName: "Area 2",
      teritoryName: "Territory B",
      minutesOfWork: 90,
      missCall: false,
      totalValidRunTime: 98.76,
      amount: 4000,
      paid: true,
    },
  ]);

  const handleAmountChange = (key: number, delta: number) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.key === key
          ? { ...item, amount: (item.amount || 0) + delta }
          : item
      )
    );
  };

  const handlePGStop = (data: any) => {};

  // const onFinish = (values: any) => {
  //   const newValues = {
  //     batchName: values?.batchName,
  //     batchCode: values?.batchCode,
  //     towerTicketLogArray: selectedRowKeys,
  //     cluster: filter?.regionId,
  //     zone: filter?.areaId,
  //   };

  //   dispatch(
  //     createBatchPaymentAsync({
  //       data: newValues,
  //       others: {
  //         reRender,
  //       },
  //     })
  //   );
  // };

  // redirect and re-render function
  // const reRender = (val: boolean) => {
  //   if (val) {
  //     form.resetFields();
  //     setSelectedRowKeys([]);
  //     addToggle();
  //     getCompletedTowerBySupplierData();
  //   }
  // };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: (newSelectedRowKeys: React.Key[]) => {
  //     setSelectedRowKeys(newSelectedRowKeys);
  //   },
  // };

  const columns: ColumnsType<GetCompletedTowerBySupplierData> = [
    {
      title: "Site Locator Name",
      dataIndex: "tower",
      render: (val) => (
        <Space className="table_column_title" size={0} direction="vertical">
          <h5>{val?.siteCode}</h5>
          <p>Tower name: {capitalize(val?.towerName)}</p>
        </Space>
      ),
    },

    {
      title: "PG Name",
      dataIndex: "pg",

      render: (val) =>
        `${val?.firstName} ${val?.lastName ? val?.lastName : ""}`,
    },
    {
      title: "Cluster",
      dataIndex: "tower",
      align: "center",

      render: (val) =>
        val?.regionName
          ? val?.regionName
              .split(" ")
              .map(
                (word: any) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")
          : "N/A",
    },
    {
      title: "Zonal",
      dataIndex: "tower",
      align: "center",
      render: (val) =>
        val?.areaName
          ? val.areaName
              .split(" ")
              .map(
                (word: any) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")
          : "N/A",
    },
    // ...(login?.role === "vendor"
    //   ? [
    //       {
    //         title: "Total Amount",
    //         dataIndex: "totalAmount",
    //         align: "center" as const,
    //         render: (val: any) => `৳ ${val ? val : 0}`,
    //       },
    //     ]
    //   : []),
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      align: "center" as const,
      render: (val: any) => `৳ ${val ? val : 0}`,
    },
    {
      title: "Missed Call",
      dataIndex: "missCall",
      align: "center",
      render: (val: boolean) => (val ? "Yes" : "No"),
    },
    {
      title: "Working Hrs",
      dataIndex: "totalValidRunTime",
      align: "center",
      render: (val) => Math.round(val || 0) + " min",
    },

    // ...(login?.role === "region"
    //   ? [
    //       {
    //         title: "Amount",
    //         dataIndex: "pg",
    //         align: "center" as const,
    //         render: (_: any, record: any) => (
    //           <div
    //             style={{
    //               display: "flex",
    //               alignItems: "center",
    //               justifyContent: "center",
    //             }}
    //           >
    //             <Button
    //               size="small"
    //               onClick={() => handleAmountChange(record.key, -1)}
    //             >
    //               -
    //             </Button>
    //             <InputNumber
    //               value={record.amount}
    //               style={{ margin: "0 8px", width: 80 }}
    //               onChange={(value) => {
    //                 if (value !== null) {
    //                   handleAmountChange(
    //                     record.key,
    //                     value - (record.amount || 0)
    //                   );
    //                 }
    //               }}
    //             />
    //             <Button
    //               size="small"
    //               onClick={() => handleAmountChange(record.key, 1)}
    //             >
    //               +
    //             </Button>
    //           </div>
    //         ),
    //       },
    //       {
    //         title: "Action",
    //         align: "center" as const,
    //         dataIndex: "paid",
    //         render: (_: any, record: NetworkTableColumn) => (
    //           <Button
    //             type="primary"
    //             onClick={() =>
    //               handleConfirmOpen({
    //                 type: "SENT_TO_VENDOR",
    //               })
    //             }
    //           >
    //             Sent to Vendor
    //           </Button>
    //         ),
    //       },
    //     ]
    //   : []),
  ];
  console.log("filter?.regionId:", filter?.regionId);
  const getCompletedTowerBySupplierData = useCallback(() => {
    const baseParams =
      keyword || siteCode
        ? { limit: 1000, skip: 0 }
        : {
            limit: limit,
            skip: limit * (page - 1),
          };

    const params: GetCompletedTowerBySupplierParams = {
      ...baseParams,
      cluster: filter?.regionId,
      area: filter?.areaId,
      page: page,
      suppler: login?.suppler,
    };

    if (login?.role === "region") {
      params.cluster = login?.region;
    }

    dispatch(
      getCompletedTowerBySupplierAsync({
        params: params,
      })
    );
  }, [
    dispatch,
    filter?.areaId,
    filter?.regionId,
    keyword,
    limit,
    login?.region,
    login?.role,
    login?.suppler,
    page,
    siteCode,
  ]);

  useEffect(() => {
    getCompletedTowerBySupplierData();
  }, [getCompletedTowerBySupplierData]);

  return (
    <>
      {confirmOpen?.type === "SENT_TO_VENDOR" && (
        <ConfirmModal
          open={confirmOpen?.open}
          data={confirmOpen?.data}
          handleClose={confirmToggle}
          deleteLoading={loading}
          handleYes={handlePGStop}
          buttonText="Yes, Send"
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
        >
          <div className="self-stretch justify-start text-zinc-700 text-xl font-semibold ">
            Do You Want to Send this to Vendor?
          </div>
          <div className="self-stretch justify-start text-zinc-700 text-base font-normal mt-2">
            Are you sure you want to send this to vendor? This won’t be undone.
            After sending these payment goes to the Zonal Head.
          </div>
        </ConfirmModal>
      )}

      {/* {addOpen?.type === "ADD_TO_BATCH_PAYMENT" && (
        <ConfirmModal
          open={addOpen?.open}
          data={addOpen?.data}
          handleClose={addToggle}
          deleteLoading={loading}
          handleYes={() => {}}
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
          buttonFooterBlank={true}
        >
          <div className="self-stretch text-center text-zinc-700 text-xl font-semibold mb-3">
            Batch Name
          </div>
          <Form
            form={form}
            layout="vertical"
            requiredMark="optional"
            onFinish={onFinish}
          >
            <Form.Item
              label="Batch Name"
              name="batchName"
              rules={[
                {
                  required: true,
                  message: "Please enter a batch name",
                },
                // {
                //   validator: async (_: any, value: string) => {
                //     if (!value) return Promise.resolve();

                //     const trimmedValue = value.trim();

                //     // Rule 1: No leading hyphen or underscore
                //     if (/^[-_]/.test(trimmedValue)) {
                //       return Promise.reject(
                //         new Error("Are not allowed start with '-' or '_'")
                //       );
                //     }

                //     // Rule 2: No decimal points
                //     if (trimmedValue.includes(".")) {
                //       return Promise.reject(
                //         new Error("Decimal points are not allowed")
                //       );
                //     }

                //     // Rule 3: No spaces
                //     if (/\s/.test(trimmedValue)) {
                //       return Promise.reject(
                //         new Error("Spaces are not allowed")
                //       );
                //     }

                //     // Rule 4: Only allow alphanumeric characters, hyphens, and underscores
                //     if (!/^[a-zA-Z0-9_-]+$/.test(trimmedValue)) {
                //       return Promise.reject(
                //         new Error(
                //           "Only alphabets, digits, hyphens (-), and underscores (_) are allowed."
                //         )
                //       );
                //     }

                //     return Promise.resolve();
                //   },
                // },
              ]}
              style={{ marginBottom: 12 }}
            >
              <Input placeholder="Enter batch name" allowClear />
            </Form.Item>

            <Form.Item
              label="Batch Code"
              name="batchCode"
              rules={[
                {
                  required: true,
                  message: "Please enter a batch code",
                },
                {
                  validator: async (_: any, value: string) => {
                    if (!value) return Promise.resolve();

                    const trimmedValue = value.trim();

                    // Rule 1: No leading hyphen or underscore
                    if (/^[-_]/.test(trimmedValue)) {
                      return Promise.reject(
                        new Error("Are not allowed start with '-' or '_'")
                      );
                    }

                    // Rule 2: No decimal points
                    if (trimmedValue.includes(".")) {
                      return Promise.reject(
                        new Error("Decimal points are not allowed")
                      );
                    }

                    // Rule 3: No spaces
                    if (/\s/.test(trimmedValue)) {
                      return Promise.reject(
                        new Error("Spaces are not allowed")
                      );
                    }

                    // Rule 4: Only allow alphanumeric characters, hyphens, and underscores
                    if (!/^[a-zA-Z0-9_-]+$/.test(trimmedValue)) {
                      return Promise.reject(
                        new Error(
                          "Only alphabets, digits, hyphens (-), and underscores (_) are allowed."
                        )
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
              style={{ marginBottom: 12 }}
            >
              <Input placeholder="Enter batch code" allowClear />
            </Form.Item>

            <div className="w-full justify-end flex gap-2 pt-4">
              <Button onClick={() => addToggle()} className="cancel_btn">
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" loading={postLoading}>
                Add Now
              </Button>
            </div>
          </Form>
        </ConfirmModal>
      )} */}

      <CustomTable<GetCompletedTowerBySupplierData>
        loading={loading}
        total={completedTowerPaginationResponse?.total || 0}
        page={completedTowerPaginationResponse?.page || 1}
        limit={completedTowerPaginationResponse?.limit || 10}
        handlePagination={handlePagination}
        columns={columns}
        // dataList={addKeyInArray(allPayment)}
        dataList={
          allCompletedTowerBySupplier
            ? addKeyInArray(allCompletedTowerBySupplier)
            : []
        }
        // {...(login?.role === "vendor" ? { rowSelection } : {})}
      />
    </>
  );
}
